<app-field-renderer
  [form]="form"
  [roles]="roleColors"
  [isRoleEditable]="isRoleEditable"
  [boundsRef]="boundsRef"
  [inBounds]="inBounds"
  [offsetRect]="offsetRect"
  [zoomScale]="zoomScale"
  [role2ColorMapping]="role2ColorMapping"
  [isCustomField]="true"
  [isValueCustomizable]="true"
  (afterMove)="onMove()"
  (afterResize)="onResize()"
  (remove)="onRemove($event)"
  (roleChange)="onRoleChange($event)"
>
  <ng-container class="title">
    <i class="far fa-text-width mr-2"></i> <ng-container i18n>Textbox</ng-container>
  </ng-container>
  <ng-container class="label">
    <i class="cs-icon cs-icon-textbox"></i>
    <ng-container *ngIf="fieldValue">
      {{ fieldValue }}
    </ng-container>
    <ng-container *ngIf="!fieldValue">
      <span *ngIf="role">{{ role }}</span> {{ label || defaultLabel }}
    </ng-container>
  </ng-container>
</app-field-renderer>
